import React, { Component, createRef } from "react";
import './index.css';
import BsyTextEditor from "../BsyTextEditor";
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsySLoading from "../BsySLoading";

export class EditStandardApp extends Component {

  constructor(props) {
    super(props)
    this.state = {
      app: props.app,
      token: "",
    }
    this.inputKeyRef = createRef();
  }

  checkToken = () => {
    const { app, token } = this.state;
    if (!this.state.token) {
      tipAlert({
        type: 'warning',
        msg: React.language("project.debug.token.empty")
      })
      this.inputKeyRef.current.focus();
      return;
    }
    if (!/^[a-z0-9_]{24}$/.test(this.state.token)) {
      tipAlert({
        type: 'warning',
        msg: React.language("project.debug.token.error")
      })
      this.inputKeyRef.current.focus();
      return;
    }

    this.setState({ isLoading: true });
    React.axios('/dashboard/standard_verify_token', {
      appId: app._id,
      token: token
    }).then(res => {
      if (res.data.code === 200) {
        this.props?.onClose()
      } else {
        tipAlert({
          type: "warning",
          msg: res.data.msg
        })
        this.setState({ isLoading: false });
      }
    }).catch(() => {
      this.setState({ isLoading: false });
    })
  }


  render() {
    const { isLoading } = this.state
    return (
      <div className={"bsy-unbind-app"}>
        <div className="input-validate"
          style={{
            display: !this.state.showAppList ? "" : "none"
          }}
        >
          <BsyTextEditor
            ref={this.inputKeyRef}
            value={this.state.token}
            hint={React.language('project.debug.token.tip')}
            onAfterEdit={(val) => {
              this.setState({ token: val });
            }}
          ></BsyTextEditor>
          <BsyIconBtn
            text={React.language('ok')}
            click={() => {
              this.checkToken();
            }}
            mode={window.mode}
          />
        </div>
        {
          isLoading && <BsySLoading />
        }
      </div>

    )
  }
}
